import script from "./RegisterEmployee.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterEmployee.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterEmployee.vue?vue&type=style&index=0&id=d632e540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d632e540"]])

export default __exports__